export const playAudio = async (url: string) => {
  const anotherOne = new Audio(url);
  await anotherOne.play();
};
